// Initial-assessment trigger shared by the QC-charts page (src/pages/chart.js)
// and the SQC print page (src/pages/sqcprint.js). Mirrored server-side in
// functions/lib/chartStage.js (recalculateChartStages) — keep the two in sync.
//
// Rule (stakeholder): count only NON-omitted points; BOTH criteria must hold:
//   1) the total of non-omitted points (setupData 1, 0 or blank) reaches the
//      configured "Initial Assessment, samples (n)" — "equal to n" is read as
//      "reaches n" so the stage does not flip back when point n+1 arrives; AND
//   2) at least MIN_SETUP_POINTS_FOR_INITIAL_ASSESSMENT of those non-omitted
//      points carry setupData = 1 (a fixed 20, independent of n).
// Otherwise the chart is "In Development". This applies both when no
// assessments exist and when assessments exist but none passed.
import { isIncludedInSqcChartSeries } from './sqcInclusion';

export const MIN_SETUP_POINTS_FOR_INITIAL_ASSESSMENT = 20;

// A missing/NaN n (config not loaded / absent) never makes the chart due,
// matching the page's previous `count >= parseInt(undefined)` behaviour.
export function isInitialAssessmentDue({ totalCount, setupOneCount, initialAssessment } = {}) {
  const n = parseInt(initialAssessment, 10);
  if (!Number.isFinite(n)) return false;
  const total = Number(totalCount) || 0;
  const one = Number(setupOneCount) || 0;
  return total >= n && one >= MIN_SETUP_POINTS_FOR_INITIAL_ASSESSMENT;
}

// Stage for a chart whose initial assessment has not (yet) passed.
export function preInitialAssessmentStage(args) {
  return isInitialAssessmentDue(args) ? 'Needs Initial Assessment' : 'In Development';
}

// Counts used by the stage decision: omitted points (omitFromSqc 'Y') are
// excluded; silenced points stay counted (isIncludedInSqcChartSeries). `total`
// includes points with a blank/missing setupData.
export function countSqcStagePoints(rows) {
  const counts = { total: 0, one: 0, zero: 0 };
  if (!Array.isArray(rows)) return counts;
  rows.forEach((row) => {
    if (!isIncludedInSqcChartSeries(row)) return;
    counts.total += 1;
    if (row.setupData === 1) counts.one += 1;
    else if (row.setupData === 0) counts.zero += 1;
  });
  return counts;
}
